import React from 'react'
import {
    Toolbar,
} from '@mui/x-data-grid-pro'

import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'

import {
    ActionComponentsKey,
} from 'app/PoC/DataGridDemoPages/SkyNetDomainV2/SkyNetDomain.types'
import QuickFilterToolbarItem from '../QuickFilterToolbarItem'
import useStyles from './SkyNetDataGridToolbar.style'
import DefaultViewToolbarActions from './DefaultViewToolbarActions'
import ReducedViewToolbarActions from './ReducedViewToolbarActions'

export type ToolbarSharedProps = {
    toolbarControls: JSX.Element[],
    showFilterButton: boolean
    toolbarActions: ActionComponentsKey[]
}

export type SetPanelTargetElFn = React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>

type Props = ToolbarSharedProps & {
    tabsComponent: JSX.Element,
    isDetailsView: boolean
    setPanelTargetEl: SetPanelTargetElFn
}

export default function SkyNetDataGridToolbar({
    toolbarControls,
    tabsComponent,
    showFilterButton,
    isDetailsView,
    setPanelTargetEl,
    toolbarActions,
}: Readonly<Props>) {
    const {
        classes,
    } = useStyles()

    return (
        <Toolbar
            data-testid="custom-toolbar"
            className={classes.toolbar}
        >
            <Box>
                {tabsComponent}
            </Box>
            <div
                className={classes.buttonsContainer}
                style={{
                    width: isDetailsView ? '100%' : undefined,
                }}
            >

                <QuickFilterToolbarItem useDynamicWidth={isDetailsView} />
                <Divider
                    orientation="vertical"
                    flexItem
                    variant="middle"
                    sx={{
                        mx: 1,
                        height: '20px',
                    }}
                />
                {isDetailsView ? (
                    <ReducedViewToolbarActions
                        toolbarControls={toolbarControls}
                        toolbarActions={toolbarActions}
                        showFilterButton={showFilterButton}
                        setPanelTargetEl={setPanelTargetEl}
                    />
                ) : (
                    <DefaultViewToolbarActions
                        toolbarControls={toolbarControls}
                        toolbarActions={toolbarActions}
                        showFilterButton={showFilterButton}
                    />
                )}
            </div>
        </Toolbar>
    )
}
